// extracted by mini-css-extract-plugin
module.exports = {"stakeItemContainer":"stake-item_stakeItemContainer__rcoFc","stakeItem":"stake-item_stakeItem__Pkbo7","betMaxBtn":"stake-item_betMaxBtn__XToqq"};